import React, { useContext, useEffect, useState } from "react";
import { useDidUpdate } from "../../../hooks/useUpdate";
import axios from "../../../axios/index";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// components
import Modal from "react-bootstrap/Modal";
import styles from "./Notification.module.css";

// styles
import ModalStyles from "../DashboardReuseAbleComponents/Modal.module.css";

export default function NotifDetailModal(props) {
  const { userToken } = useContext(UserContext);
  const [notifDetail, setNotifDetail] = useState([]);
  // const [btnLoader, setBtnLoader] = React.useState(false)

  useDidUpdate(() => {
    if (props.show) {
      const getNotifDetail = async () => {
        const getData = await axios.get(`Notification/UserNotification/${props.id}`, {
          headers: { authorization: "Bearer " + userToken },
        });
        // console.log(getData.data)
        setNotifDetail(getData.data.data);
      };
      getNotifDetail();
    }
  }, [props.show, props.id]);

  return (
    <>
      <style type="text/css">
        {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
        {/* 
                    // height: 671px;
             */}
      </style>
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton dir="rtl">
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>جزییات اعلان</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="w-100 d-flex align-items-center justify-content-start flex-column flex-wrap p-md-4 p-3" dir="rtl">
            <div className="w-100 d-flex justify-content-md-between align-items-center mb-3 flex-wrap justify-content-start">
              <div className={`d-flex flex-column align-items-start justify-content-center my-md-0 my-1 text-end ${styles.w_100}`}>
                <h5 className={styles.text_gray}>عنوان :</h5>
                <h3 className={styles.text_dark}>{notifDetail?.title?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</h3>
              </div>
              <div className={`d-flex align-items-center justify-content-md-center justify-content-start my-md-0 my-1 text-end ${styles.w_100}`}>
                <span className={styles.text_gray}>تاریخ :</span>{" "}
                <div className={styles.text_dark}>{notifDetail?.createDate?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
              </div>
            </div>
            <div className="w-100 d-flex flex-column justify-content-center align-items-center my-3">
              <div className="w-100 d-flex align-items-center justify-content-start">
                <h5 className={styles.text_gray}>متن پیام :</h5>
              </div>

              <div className="w-100 d-flex align-items-center justify-content-center my-3 px-4 text-end">
                <div className={styles.text_dark}>{notifDetail?.body}</div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-center align-items-center mb-3">
            <div className={`d-flex align-items-center justify-content-center me-3 ${ModalStyles.outlined_btn}`} onClick={props.onHide}>
              باشه
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
